import { initialAdSlotsState, AdSlotsState } from 'mk2/containers/AdSlot/AdSlot.reducers';
import { AppState } from 'mk2/reducers';

export const getAdSlotsState = (state: AppState): AdSlotsState | null => {
    return state.containers.global.adSlot || initialAdSlotsState;
};

